import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { DashboardScreen } from '../screens/dashboard/DashboardScreen';
import { VehicleListScreen } from '../screens/vehicle/VehicleListScreen';
import { Ionicons } from '@expo/vector-icons';
import { TouchableOpacity } from 'react-native';
import theme from '../theme';

const Stack = createStackNavigator();

export const DashboardNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false, // Disable all headers since we have custom header
      }}
    >
      <Stack.Screen 
        name="Dashboard" 
        component={DashboardScreen} 
      />
      <Stack.Screen 
        name="VehicleList" 
        component={VehicleListScreen}
      />
    </Stack.Navigator>
  );
};
